import Dexie, { type EntityTable } from "dexie";

export interface Category {
  id: string;
  name: string;
  handle: string;
  sort_order: number;
  description: string | null;
  image_url: string | null;
}

export interface Product {
  id: string;
  name: string;
  handle: string;
  description: string | null;
  short_description: string | null;
  category_id: string | null;
  active: boolean;
  sort_order: number;
  image_url: string | null;
  specs: Record<string, any>;
  created_at?: string;
}

export interface ProductCategory {
  product_id: string;
  category_id: string;
  created_at?: string;
}

export interface Inquiry {
  id: string;
  email: string;
  created_at?: string;
}

export interface InquiryItem {
  id: string;
  inquiry_id: string;
  product_handle: string;
}

const isServer = typeof window === "undefined";

export const db = (isServer ? {} : new Dexie("QTXDatabase")) as Dexie & {
  categories: EntityTable<Category, "id">;
  products: EntityTable<Product, "id">;
  product_categories: EntityTable<ProductCategory, "product_id">;
  inquiries: EntityTable<Inquiry, "id">;
  inquiry_items: EntityTable<InquiryItem, "id">;
};

if (!isServer) {
  db.version(5).stores({
    categories: "id, handle, name, sort_order",
    products: "id, handle, category_id, active, sort_order",
    product_categories: "[product_id+category_id], product_id, category_id",
    inquiries: "id, email, created_at",
    inquiry_items: "id, inquiry_id, product_handle",
  });
}
